import { ChangeDetectionStrategy, Component, inject, type OnInit } from "@angular/core";
import { Router } from "@angular/router";

import { IconComponent } from "../../../shared/components/icon/icon.component";
import { AUTH_PROVIDER } from "../../../core/auth/auth-provider.token";
import { AUTH_CONTEXT } from "../../../core/auth/auth-context.token";
import { AuthService } from "../../../core/services/auth.service";

@Component({
  selector: "app-login",
  standalone: true,
  imports: [IconComponent],
  templateUrl: "./login.component.html",
  styleUrl: "./login.component.scss",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoginComponent implements OnInit {
  private readonly authProvider = inject(AUTH_PROVIDER);

  private readonly authState = inject(AuthService);

  private readonly router = inject(Router);

  protected readonly authContext = inject(AUTH_CONTEXT);

  ngOnInit(): void {
    // A user who reaches /login with a valid session (e.g. SSO already
    // resolved the account during bootstrap) should not see the login screen.
    if (this.authState.isAuthenticated()) {
      void this.router.navigate(["/"]);
    }
  }

  protected signIn(): void {
    void this.authProvider.login(null);
  }
}
